//API URLs
export const API = {
  getPaymentDetails: "/merchant/init-payment/",
  makePayment: "/merchant/confirm",
};

export const GOOGLE_ANALYTICS = {
  TRACKING_ID: "UA-168575982-1"
};


// WEBPACK FOOTER //
// ./src/constants/AppConstants.js